import React, {Component} from 'react'

import AnchorButton from '../AnchorButton'

import './styles.css'

const CROWDRISE_ROOT = 'https://www.crowdrise.com/donate/charity/forestandsea/'

class Checkout extends Component {
  static defaultProps = {
    checkout: 'Checkout',
    showAmount: true,
  }

  render() {
    const {preamble, label, caption, amount, anchor, checkout, co2, type, monthly, showAmount} = this.props
    const base = `${CROWDRISE_ROOT}${amount}?`
    const reqParams = 'utm_source=carbotax.org&utm_campaign=carbotax'
    const extraParams = `&utm_co2=${co2}&utm_type=${type}`
    const recurringParam = monthly ? `&monthly=${monthly}` : ''
    const crowdrise = `${base}${reqParams}${extraParams}${recurringParam}`

    return (
      <div className="checkout" id={anchor}>
        {preamble}
        {label && <div className="checkout-label">{label}</div>}
        {showAmount && amount && <div className="checkout-amount">${amount}</div>}
        <AnchorButton className="checkout-btn" href={crowdrise}>
          {checkout}
        </AnchorButton>
        {caption && <div className="checkout-caption">{caption}</div>}
      </div>
    )
  }
}

export default Checkout



// WEBPACK FOOTER //
// ./src/components/Checkout/index.js